export class LoginMessage {
  constructor(public successfull: boolean) {
  }
}
